import { FLAGS } from 'shared/utils/launchdarkly/flags';
/* For use in helpers or outside of hook context */
export var getFlagEnabled = function (flag, launchDarklyClient) {
    return !!launchDarklyClient.allFlags()[FLAGS[flag].name];
};
/*
  useFlagEnabled is a helper method that returns the truthy value of `FLAGS['flag name'].useFlag()`, intended for use
  cases with boolean flags.
*/
export var useFlagEnabled = function (flag) {
    var flagEnabled = !!FLAGS[flag].useFlag();
    return flagEnabled;
};
